import React from "react";
import "./../WebPageExperience/WebPageExperience.css";
import scability from "./../../../Assets/scability.png";
import cloudnative from "./../../../Assets/cloud native.png";
import device from "./../../../Assets/device comp.png";
import uiux from "./../../../Assets/ui ux.png";
import webapp from "./../../../Assets/web app.png";
import saaswebapp from "./../../../Assets/saas web app.png";
import frontend from "./../../../Assets/frontend.png";
import backend from "./../../../Assets/backend.png";
import customapp from "./../../../Assets/custom web app.png";
import moderntech from "./../../../Assets/modern stak.png";
import usablity from "./../../../Assets/usability.png";
import { Helmet } from "react-helmet"


function WebPageExperience() {
  return (
    <>
    <Helmet>
      <script type="application/ld+json">
        {`
        {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Web Application Development Services",
  "provider": {
    "@type": "Organization",
    "name": "360 SynergyTech",
    "url": "https://360synergytech.com/"
  },
  "serviceType": "Custom Web Application Development",
  "areaServed": {
    "@type": "Country",
    "name": "USA"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Web App Development Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Scalable Web Applications",
          "description": "We build highly scalable software solutions that grow with your business, ensuring smooth performance and reliability under increased traffic and data load."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Cloud-Native Development",
          "description": "Cloud-native apps built on AWS, Azure, and Google Cloud for seamless deployments, global accessibility, and reduced infrastructure costs."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Device Compatibility",
          "description": "Cross-device compatible applications ensuring smooth performance on desktop, mobile, and tablets with responsive design."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Delightful UX/UI",
          "description": "User-friendly designs combining aesthetics with usability to create intuitive, engaging, and accessible experiences."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Inclusive Web Apps",
          "description": "Web apps built to meet accessibility standards, ensuring usability for diverse users across all devices."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "SaaS Web App Development",
          "description": "Secure and scalable SaaS solutions with multi-tenant architectures, automated billing, and subscription-ready platforms."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Frontend Development",
          "description": "Visually stunning and interactive frontends built with React, Vue, and Angular for superior user experiences."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Backend Development",
          "description": "High-performance backends built with Node.js, Python, and enterprise databases for speed, scalability, and security."
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Custom Web Apps",
          "description": "Tailor-made applications designed to meet unique business needs and industry-specific challenges."
        }
      }
    ]
  }
}
`}

      </script>
    </Helmet>
    <div className="main_div_WebPageExperience">
      <div className="row p-0 m-0">
        <div className="col-12">
          <h2 className="heading_webexp">
            We Craft exceptional solutions in software development and
            customization
          </h2>
          <div className="d-flex justify-content-center">
            <div className="hr_line_blue_web" />
          </div>
          <div className="row m-0 p-0">
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={scability} width="58" height="59" alt="Scalability"/>
                <h3 className="Scalability_heading">Scalability</h3>
                <p className="Scalability_para">
                  We build highly scalable software solutions that adapt to your growing business needs. Our architecture ensures smooth performance, reliability, and cost-efficiency at every stage.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={cloudnative} width="59" height="59" alt="Cloud-Native" />
                <h3 className="Scalability_heading">Cloud-Native</h3>
                <p className="Scalability_para">
                  Our cloud-native applications leverage AWS, Azure, and Google Cloud for seamless deployments, unmatched uptime, and lightning-fast performance, with reduced infrastructure overhead.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={device} width="58" height="59" alt="Device Compatibility"/>
                <h3 className="Scalability_heading">Device Compatibility</h3>
                <p className="Scalability_para">
                  We design and develop web applications optimized for desktops, tablets, and mobile devices, with responsive frameworks that perform flawlessly across all screen sizes.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={uiux} width="58" height="58" alt="Delightful UX/UI"/>
                <h3 className="Scalability_heading">Delightful UX/UI</h3>
                <p className="Scalability_para">
                  Our UX/UI design combines creativity with functionality. By focusing on user psychology, accessibility, and interactive design patterns, we deliver interfaces that enhance engagement.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={webapp} width="58" height="59" alt="Web App for All"/>
                <h3 className="Scalability_heading">Web App for All</h3>
                <p className="Scalability_para">
                  We build inclusive web apps that meet WCAG and accessibility standards. From keyboard navigation to screen-reader compatibility, our solutions guarantee usability for diverse users.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={saaswebapp} width="58" height="58" alt="SaaS Web App Developmen"/>
                <h3 className="Scalability_heading">SaaS Web App Development</h3>
                <p className="Scalability_para">
                  Our SaaS solutions are secure, subscription-ready, and built for scalability, with multi-tenant architectures, automated billing systems, and strong APIs for fast go-to-market launches.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={frontend} width="58" height="58" alt="Frontend Web App Development" />
                <h3 className="Scalability_heading">
                  Frontend Web App Development
                </h3>
                <p className="Scalability_para">
                  We build dynamic and visually engaging frontends with React, Vue, and Angular, using optimized performance, reusable components, and smooth animations.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={backend} width="59" height="58" alt="Backend Web App Development"/>
                <h3 className="Scalability_heading">
                  Backend Web App Development
                </h3>
                <p className="Scalability_para">
                  Our backend development ensures performance, scalability, and rock-solid security. Using Node.js, Python, and enterprise databases, we build APIs, authentication systems, and data pipelines.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12 d-flex">
              <div className="card_div_web">
                <img src={customapp} width="58" height="58" alt="Custom Web App Development"/>
                <h3 className="Scalability_heading">
                  Custom Web App Development
                </h3>
                <p className="Scalability_para">
                  Every business is unique, and so are our solutions. We deliver tailor-made applications aligned with your goals, whether ERP, CRM, or industry-specific platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default WebPageExperience;
